import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AchipoHomePage from './components/USPAHomePage';
import EventsPage from './components/EventsPage';
import MembersPage from './components/MembersPage';
import RulesPage from './components/RulesPage';
import RecordsPage from './components/RecordsPage';
import RankingsPage from './components/RankingsPage';
import ClassificationPage from './components/ClassificationPage';
import ShopPage from './components/ShopPage';
import AssociatesPage from './components/AssociatesPage';
import CartPage from './components/CartPage';
import CheckoutPage from './components/CheckoutPage';
import PagoExitosoPage from './components/PagoExitosoPage';
import PagoCanceladoPage from './components/PagoCanceladoPage'; 
import ProductDetailPage from './components/ProductDetailPage';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ConfirmEmail from './components/ConfirmEmail';
import AdminPanel from './components/AdminPanel';
import ProfilePage from './components/ProfilePage';
import PostularEventoPage from './components/PostularEventoPage';
import PresidentClubPage from './components/PresidentClubPage';
import EventInternalFormPage from './components/EventInternalFormPage';
import MisEventosPage from './components/MisEventosPage';
import CMS from './components/CMS';
import CheckoutSuccess from './components/CheckoutSuccess';
import CheckoutFailure from './components/CheckoutFailure';
import ScrollToTop from './components/ScrollToTop';
import NotFoundPage from './components/NotFoundPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  const ProtectedRoute = ({ children }) => {
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    return isAdmin ? children : <Navigate to="/login" />;
  };

  const AuthRoute = ({ children }) => {
    const token = localStorage.getItem('access_token');
    return token ? children : <Navigate to="/login" state={{ from: window.location.pathname }} />;
  };

  return (
    <div className="App">
      <div className="page-transition-wrapper" key={location.pathname}>
        <Routes location={location}>
          {/* Rutas públicas */}
          <Route path="/" element={<AchipoHomePage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route
            path="/events/:id/formulario"
            element={
              <AuthRoute>
                <EventInternalFormPage />
              </AuthRoute>
            }
          />
          <Route path="/members" element={<MembersPage />} />
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/records" element={<RecordsPage />} />
          <Route path="/rankings" element={<RankingsPage />} />
          <Route path="/clasificacion" element={<ClassificationPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/shop" element={<ShopPage />} /> 
          <Route path="/associates" element={<AssociatesPage />} />
          <Route path="/cart" element={<CartPage />} /> 
          
          {/* Rutas de autenticación */}
          <Route path="/login" element={<Login />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route
            path="/profile/presidente-club"
            element={
              <AuthRoute>
                <PresidentClubPage />
              </AuthRoute>
            }
          />
          <Route
            path="/profile/mis-eventos"
            element={
              <AuthRoute>
                <MisEventosPage />
              </AuthRoute>
            }
          />
          <Route
            path="/profile/postular-evento"
            element={
              <AuthRoute>
                <PostularEventoPage />
              </AuthRoute>
            }
          />
          
          {/* Rutas de E-Commerce */}
          <Route 
            path="/checkout" 
            element={
              <AuthRoute>
                <CheckoutPage />
              </AuthRoute>
            } 
          />
          <Route path="/pago-exitoso" element={<PagoExitosoPage />} />
          <Route path="/pago-cancelado" element={<PagoCanceladoPage />} />
          
          {/* Rutas protegidas de administración */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/cms"
            element={
              <ProtectedRoute>
                <CMS />
              </ProtectedRoute>
            }
          />

          {/* 404 - Página no encontrada */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;